import { initTheme } from "@/utils/theme";

import { IChannelConfigs, IChannelTheme } from "../types";
import CharlotteFooter from "./components/Layout/Footer.vue";
const theme: IChannelTheme = {};
export default {
  configs: {
    benefitIcons: {
      luxury:
        "https://uploads.ytripos.com/uploaded/FtHqZc95JoTP5di67BjorqnWz5pb/charlotte_list_luxury.png?imageView2/2/format/webp/w/240"
    },
    benefitDetailIcons: {
      luxury:
        "https://uploads.ytripos.com/uploaded/FkqexDQAkJqh3bAuFyfNi7wt-qhu/charlotte_detail_luxury.png?imageView2/2/format/webp/w/240"
    },
    useChannelLogo: true,
    useChannelLanguages: true,
    components: {
      Footer: {
        component: CharlotteFooter
      }
    },
    currency: "local",
    pages: {
      Index: {
        leftLogoUrl:
          "https://uploads.ytripos.com/uploaded/FrJMgfzPlHPIBpdwFDUolLYeAMRy/LOCKUP.png",
        banners: {
          list: [
            {
              img: "https://uploads.ytripos.com/uploaded/FhexdAHurUM_0XKA8VisKp7LIiVd/Y_homebanner_web@3x.webp"
            }
          ]
        }
      }
    }
  },
  init() {
    initTheme(theme);
  }
} as IChannelConfigs;
